"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mark = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ORIGINAL_WIDTH = 20;
var ORIGINAL_HEIGHT = 17;
// props に依存しない静的 path なのでモジュールスコープに 1 度だけ生成して使い回す。
// 座標は svgo（precision=2）で最適化済み（視覚差なし・元データ比 約46%削減）。
var MARK_PATH = ((0, jsx_runtime_1.jsx)("path", { d: "M20 4.15v8.25a4.5 4.5 0 0 1-4.38 4.58 4.5 4.5 0 0 1-4.48-4.53V8.88l-5.86-6a1.7 1.7 0 0 0-1.9-.38c-.68.29-1.08.9-1.08 1.65v8.3c0 1.22.98 2.2 2.18 2.18a2.2 2.2 0 0 0 2.07-2.22V8.1c0-.22.26-.33.41-.17l1.76 1.8q.14.13.14.33v2.34a4.5 4.5 0 0 1-4.39 4.58A4.5 4.5 0 0 1 0 12.45v-8.3C0 2.45.96.98 2.5.33a3.9 3.9 0 0 1 4.41.9l6.2 6.34q.34.34.34.82v4.02c0 1.2.91 2.2 2.07 2.22 1.2.03 2.18-.96 2.18-2.18v-8.3c0-.75-.4-1.36-1.08-1.65a1.7 1.7 0 0 0-1.9.39l-1.3 1.32q-.17.15-.34 0L11.8 2.9a.25.25 0 0 1 0-.34l1.3-1.33a3.9 3.9 0 0 1 4.41-.9A4.1 4.1 0 0 1 20 4.16", fill: "#06C755" }));
var Mark = function (_a) {
    var _b = _a.size, size = _b === void 0 ? ORIGINAL_WIDTH : _b, props = __rest(_a, ["size"]);
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: size, height: (size * ORIGINAL_HEIGHT) / ORIGINAL_WIDTH, viewBox: "0 0 ".concat(ORIGINAL_WIDTH, " ").concat(ORIGINAL_HEIGHT), fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: MARK_PATH })));
};
exports.Mark = Mark;
